module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm._inputBoxStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "inputBox weex-ct weex-div",
    style: ({
      borderRadius: _vm.borderRadius
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('input', {
    staticClass: "input",
    style: (_vm._px2rem(_vm._inputStyle, 75)),
    attrs: {
      "type": _vm.type_,
      "autofocus": _vm.autofocus,
      "maxlength": _vm.maxlength,
      "return-key-type": _vm.returnKeyType,
      "singleline": _vm.singleline,
      "max": _vm.max,
      "min": _vm.min,
      "upriseOffset": _vm.upriseOffset,
      "hideDoneButton": _vm.hideDoneButton,
      "placeholder": _vm.placeholder,
      "data-evt-input": ""
    },
    domProps: {
      "value": _vm.value
    },
    nativeOn: {
      "input": function($event) {
        $event.stopPropagation();
        return _vm.input($event)
      }
    }
  }), _vm._v(" "), (_vm.isShowRight) ? _c('div', {
    staticClass: "right weex-ct weex-div",
    style: ({
      backgroundColor: _vm._inputStyle.backgroundColor
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm._isShowClear && _vm._isColmo) ? _c('dof-iconfont', {
    staticClass: "icon",
    attrs: {
      "code": '\u4725',
      "size": 48,
      "color": _vm._isColmo ? '#78797A' : '#1E2E37',
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": _vm.handleClear
    }
  }) : _vm._e(), _vm._v(" "), (_vm._isShowClear && !_vm._isColmo) ? _c('figure', {
    staticClass: "clearImg weex-el weex-image",
    attrs: {
      "src": _vm.iconImg.empty,
      "data-img-src": _vm.iconImg.empty,
      "weex-type": "image",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.handleClear($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowPWDIcon && _vm._isColmo) ? _c('dof-iconfont', {
    staticClass: "icon",
    attrs: {
      "code": _vm.PWDIcon,
      "size": 48,
      "color": _vm._isColmo ? '#78797A' : '#1E2E37',
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": _vm.handleTogglePWD
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowPWDIcon && !_vm._isColmo) ? _c('figure', {
    staticClass: "PWDImg weex-el weex-image",
    attrs: {
      "src": _vm.PWDImg,
      "data-img-src": _vm.PWDImg,
      "weex-type": "image",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.handleTogglePWD($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("right", null, {})], 2) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7fafbf05", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fafbf05","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-input/index.vue
// module id = 648
// module chunks = 0 1